import React from 'react';

const DashboardCard = ({ card, onClick }) => {
  const iconMap = {
    'users': '👥',
    'chart-bar': '📊',
    'chart-line': '📈',
    'cog': '⚙️',
    'bell': '🔔',
    'envelope': '✉️',
    'calendar': '📅',
    'tasks': '✓',
    'project-diagram': '📋',
    'file-alt': '📄',
    'address-book': '📇',
    'file-invoice-dollar': '💰',
    'warehouse': '📦',
    'user-tie': '👔',
    'graduation-cap': '🎓',
    'headset': '🎧',
    'shopping-cart': '🛒',
    'bullhorn': '📢',
    'dollar-sign': '💵',
    'shield-alt': '🛡️',
    'plug': '🔌',
    'certificate': '📜',
    'clipboard-check': '✅',
    'file-code': '💻',
  };

  return (
    <div 
      className="dashboard-card" 
      onClick={() => onClick && onClick(card)}
    >
      <div className="card-icon">
        {iconMap[card.icon] || '📌'}
      </div>
      <div className="card-content">
        <h3 className="card-title">{card.title}</h3>
        <p className="card-description">{card.description}</p>
      </div>
    </div>
  );
};

export default DashboardCard;
